import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { ExportExcelService, IExportTemplate } from "../../../../auth/service/export-excel.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { TranslationDatabaseService } from "../../../../auth/service/translation-database.service";

@Component({
  selector: "app-export-excel",
  templateUrl: "./export-excel.component.html",
  styleUrls: ["./export-excel.component.scss"]
})
export class ExportExcelComponent implements OnInit {
  column1: Array<string> = [];
  column2: Array<string> = [];
  labels: Array<string> = [];
  translations: any = [];
  selectedTemplate: IExportTemplate | null = null;
  private allLabels: Array<string> = [];
  newExportTemplateName: string = "";
  templatesList: Array<any> = [];

  constructor(
    private _modalService: NgbModal,
    public _exportExcelService: ExportExcelService,
    private _utilService: UtilsService,
    private _translationService: TranslationDatabaseService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
  }

  async ngOnInit() {
    this._exportExcelService.labels.subscribe(labels => {
      this.column1 = [...labels];
      this.labels = [...labels];
      this.allLabels = [...labels];
    });

    this._exportExcelService.getTemplates().subscribe(templates => {
      const area: string = this._exportExcelService.area.value;
      this.templatesList = templates.filter((template: any) => template.area === area);
    });

    await this._translationService.getList()
      .then((res: any) => {
        let translations = {};
        res
          .filter((translation: any) => translation.language.toLowerCase().startsWith("it"))
          .forEach((translation: any) => {
            translations[translation.field] = translation.label;
          });
        this.translations = translations;
      });
  }

  drop(event: CdkDragDrop<string[]>): void {
    // Controls in which array the widget are gonna landing
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  clean(): void {
    this.newExportTemplateName = "";
    this.column1 = [...this.allLabels];
    this.column2 = [];
  }

  moveLabel(label: string): void {
    const sourceColumn = this.column1.includes(label) ? this.column1 : this.column2;
    const targetColumn = this.column1.includes(label) ? this.column2 : this.column1;
    sourceColumn.splice(sourceColumn.indexOf(label), 1);
    targetColumn.push(label);
    this._changeDetectorRef.detectChanges();
  }

  selectAllColumns(): void {
    this.clean();
    this.column2 = this.column2.concat(this.column1);
    this.column1 = [];
  }

  async export() {
    try {
      this._utilService.showLoading();
      const dataFile: any = this._exportExcelService.dataForExport.value;

      if (!!dataFile && dataFile.length > 0) {
        // get all translations before calling exportAsExcelFile
        Promise.all(this.column2.map(field => this.translations[field]))
          .then(async translations => {
            const translatedColumnNames: any = this.column2.reduce((acc, field, index) => {
              acc[field] = translations[index];
              return acc;
            }, {});

            const yes: any = await this._utilService.translate("YES");
            const no: any = await this._utilService.translate("NO");

            const mappedData = dataFile.map((element: any) => this.column2.reduce((acc, field) => {
              let value = element[field];

              if (Array.isArray(value)) {
                if (value.length > 0) {
                  value = value.filter((value, index: number, self) => self.indexOf(value) === index).join(", ");
                } else {
                  value = "";
                }
              }

              switch (field) {
                case "educations":
                  value = (element.educations || []).map((ed: any) => `${ed.title_name} ${ed.graduate_name} ${ed.vote}`).join(", ");
                  break;
                case "addresses":
                  if (element[field]) {
                    const residence: any = element[field].find((add: any) => add.label === "residenza");
                    const domicile: any = element[field].find((add: any) => add.label === "domicilio");
                    const shipment: any = element[field].find((add: any) => add.label === "spedizione");
                    if (residence) {
                      const fieldAddress = this.translations.residence_address;
                      acc[fieldAddress] = `${residence.street} ${residence.city_name || ""} ${residence.province_name || ""} ${residence.zipcode || ""}`.trim();
                    }
                    if (domicile) {
                      const fieldAddress = this.translations.domicile_address;
                      acc[fieldAddress] = `${domicile.street} ${domicile.city_name || ""} ${domicile.province_name || ""} ${domicile.zipcode || ""}`.trim();
                    }
                    if (shipment) {
                      const fieldAddress = this.translations.shipment_address;
                      acc[fieldAddress] = `${shipment.street} ${shipment.city_name || ""} ${shipment.province_name || ""} ${shipment.zipcode || ""}`.trim();
                    }
                  }
                  break;
                case "socials":
                  value = (Array.isArray(element[field]) ? element[field] : []).map((social: any) => social.url).join(", ");
                  value = value == 0 ? "" : value;
                  break;
                case "description":
                  value = this._utilService.stripHTML(value);
                  break;
                default:

                  if (field.includes("_date") || field == 'birthday') {
                    value = this._utilService.formatDate(value);
                  }

                  value = (Number(element[field]) == 1) ? yes : value;
                  value = (Number(element[field]) == 0 && element[field]?.toString().length === 1) ? no : value;
                  break;
              }

              acc[translatedColumnNames[field]] = value;
              if (field == "addresses") {
                delete acc[translatedColumnNames[field]];
              }

              return acc;
            }, {}));

            this._utilService.hideLoading();
            this._utilService.exportAsExcelFile(mappedData, this._exportExcelService.fileName.value);
            this.closeModal();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_EXPORT_EXCEL" });
          })
          .catch(async (error: any) => {
            this._utilService.hideLoading();
            console.error(error);
            await this._utilService.showSWALError({ text: "ERROR_EXPORT_EXCEL" });
          });
      }
    } catch (e: any) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_EXPORT_EXCEL" });
      console.error(e.message);
    }
  }

  loadTemplate() {
    this.clean();
    if (!!this.selectedTemplate) {
      const { columns }: Array<string> | any = this.selectedTemplate;
      this.column2 = [...columns];
      this.column1 = [...this.allLabels].filter(label => !columns.includes(label));
    }
  }

  closeModal(): void {
    this._modalService.dismissAll();
  }

  async saveTemplate() {
    try {
      this._utilService.showLoading();
      const area: string = this._exportExcelService.area.value;
      this._exportExcelService.saveTemplate(this.newExportTemplateName, this.column2, area)
        .subscribe(() => {
          this._exportExcelService.getTemplates().subscribe(templates => {
            this.templatesList = templates.filter((template: IExportTemplate) => template.area === area);
          });
          this._exportExcelService.getTemplate(this.newExportTemplateName).subscribe((result: any) => {
            this.selectedTemplate = result;
            this.newExportTemplateName = "";
            this._utilService.showSWALSuccess({ text: "SUCCESS_SAVE_TEMPLATE" });
            this._utilService.hideLoading();
          });
        });
    } catch (e: any) {
      await this._utilService.showSWALError({ text: "ERROR_SAVE_TEMPLATE" });
      console.error(e);
    }
  }

  async editTemplate() {
    try {
      this._utilService.showLoading();
      this._exportExcelService.updateTemplate(this.selectedTemplate.name, this.column2)
        .subscribe(() => {
          this.selectedTemplate.columns = this.column2;
          this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_TEMPLATE" });
          this._utilService.hideLoading();
        });
    } catch (e: any) {
      await this._utilService.showSWALError({ text: "ERROR_EDIT_TEMPLATE" });
      console.error(e);
    }
  }

  deleteTemplate() {
    try {
      this._utilService.showSWALDeleteConfirmation({ text: "DELETE_TEMPLATE_CONFIRMATION" })
        .then((res: any) => {
          if (res.isConfirmed) {
            this._exportExcelService.deleteTemplate(this.selectedTemplate.name)
              .subscribe(() => {
                this.templatesList = this.templatesList.filter((template: any) => template.name !== this.selectedTemplate.name);
                this.selectedTemplate = null;
                this.clean();
                this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_TEMPLATE" });
              });
          } else {
            this._utilService.showSWALError({ title: "ABORTED_TITLE", text: "ABORTED_TEXT" });
          }
        });
    } catch (e: any) {
      this._utilService.showSWALError({ text: "ERROR_DELETE_TEMPLATE" });
      console.error(e);
    }
  }
}